/** Default checked state for Background Data Completeness → A1-A3. */
export const DEFAULT_A1_A3_CHECKED = true;

export function resolveA1A3CheckboxDefault(): string {
  return DEFAULT_A1_A3_CHECKED ? "true" : "false";
}
